'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _ingredientAutocomplete = require('./ingredient-autocomplete.component');

var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.autocomplete.ingredient', []).component('ingredientAutocomplete', _ingredientAutocomplete2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/ingredient/ingredient-autocomplete.module.js